import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../App.css";

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateMessage, setStateMessage] = useState(null);
  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          setStateMessage("Message sent!");
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        },
        (error) => {
          setStateMessage("Something went wrong, please try again later");
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        }
      );

    // Clears the form after sending the email
    e.target.reset();
  };
  return (
    <section class="contact" id="contact">
      <div>
        <h1
          style={{ textAlign: "center", fontFamily: "62.5%" }}
          id="contact_me"
        >
          {" "}
          Contact Me
        </h1>

        <div id="form-main">
          <div id="form-div">
            <form class="form" id="form1" onSubmit={sendEmail}>
              <p class="name">
                <input
                  type="text"
                  name="from_name"
                  class="validate[required,custom[onlyLetter],length[0,100]] feedback-input"
                  placeholder="Name"
                  id="name"
                />
              </p>

              <p class="email">
                <input
                  type="email"
                  name="user_email"
                  class="validate[required,custom[email]] feedback-input"
                  id="email"
                  placeholder="Email"
                />
              </p>

              <p class="text">
                <textarea
                  name="message"
                  class="validate[required,length[6,300]] feedback-input"
                  id="comment"
                  placeholder="Message"
                ></textarea>
              </p>

              <div class="submit">
                <input
                  type="submit"
                  value="SEND"
                  disabled={isSubmitting}
                  id="button-blue"
                />
                {stateMessage && window.alert(stateMessage)}
                <div class="ease"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactForm;
